import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { type PageLayoutStore } from 'shared/layout'
import { type ActionItem, ContainerHeader } from 'shared/ui'
import {
  ClickToTextNewButton,
  ClickToTextHelpGuideButton,
} from 'pages/clickToText/pages/all/ui/ClickToTextButtons'

type IClickToTextListHeaderProps = {
  title: string
  pageLayoutStore: PageLayoutStore
  isClickToTextActionShown: boolean
}

export const ClickToTextListHeader = observer(
  ({ title, pageLayoutStore, isClickToTextActionShown }: IClickToTextListHeaderProps) => {
    const { titleIconProps, handleToggleCollapse } = pageLayoutStore

    const actions: ActionItem[] = useMemo(() => {
      if (!isClickToTextActionShown) {
        return []
      }
      return [
        { iconButtonComponent: <ClickToTextHelpGuideButton /> },
        {
          iconButtonComponent: <ClickToTextNewButton />,
        },
      ]
    }, [isClickToTextActionShown])
    return (
      <ContainerHeader
        title={title}
        titleVariant={'heading-md'}
        titleIconProps={titleIconProps}
        titleIconAction={handleToggleCollapse}
        paddingLeft={20}
        actions={actions}
        actionsGap={8}
      />
    )
  }
)
